// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".build_box[data-v-2a4ae7b2]{background:#f5f5f5;margin-bottom:10px}.build_header[data-v-2a4ae7b2]{width:100%;display:flex;justify-content:space-between;align-items:center;padding:0 20px 0 10px}.build_header .num_checked[data-v-2a4ae7b2]{color:#999}.build_header .num_checked .checked[data-v-2a4ae7b2]{color:#ff3973}.build_header .num_checked .device_all[data-v-2a4ae7b2]{color:#282729}", ""]);
// Exports
module.exports = exports;
